export default __webpack_public_path__ + "static/slide1@2x-04e4ea284991def082573ee15c80f3d7.png";